<template>
    <div class="container-fluid">
      <!-- Header -->
      <div class="columns is-centered h-60px pd-vtc-12px is-marginless hdr">
        <div class="column is-paddingless h-36px">
          <router-link :to="{ name: 'Home' }" exact>
            <div class="cs-pointer title is-4 exit">
              <i class="fas fa-times"></i>
            </div>
          </router-link>
        </div>
      </div>
      <!-- End Header -->

      <!-- List Item -->
      <div class="list-item">
        <div class="pst-fixed mg-auto t-0px l-0px r-0px bt-0px w-fit-content h-fit-content t-al-center ">
          <qrcode-reader @decode="onDecode" :paused="paused">
          </qrcode-reader>
        </div>
      </div>
      <!-- End List Item -->

      <!-- Footer -->
      <div class="columns is-centered h-100px pd-hrzt-30px is-marginless ft">
        <div class="column is-6 is-paddingless">
          <span class="f-left total-price title is-3" > ฿ {{ netPrice  | showFullPriceFormat()}}  </span>
          <router-link :to="{ name: 'Cart'}" exact class="f-right" v-if="amount != 0">
            <div>
              <div class="tag cart-item-count is-danger pst-absolute mg-t-15px mg-l-15px w-30px h-30px" v-if="this.amount !== 0">
                {{ amount }}
              </div>
            </div>
            <img id="cart" src="@/assets/shopping-cart.png" class="footer-icon">
          </router-link>

          <div class="f-right" v-else>
            <img id="cart" src="@/assets/shopping-cart.png" class="footer-icon-disable">
          </div>

        </div>
      </div>
      <!--End Footer -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'scan-cart',
  data () {
    return {
      paused: false
    }
  },
  methods: {
    ...mapActions([
      'addItem'
    ]),
    async onDecode (content) {
      if (content) {
        let contents = content.split('/')
        let idOfProdect = contents[contents.length - 1]
        if (await this.addItem(idOfProdect)) {
          await this.playSound()
        } else {
          this.$dialog.alert({
            title: 'เกิดข้อผิดพลาด',
            confirmText: 'ตกลง',
            message: 'ไม่พบสินค้าในคลัง'
          })
        }
      }
      this.paused = true
      await this.delayScan(1500)
    },
    playSound () {
      let audio = new Audio(require('@/assets/sound/tid.mp3'))
      audio.play()
    },
    delayScan (timeout) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.paused = false)
        }, timeout)
      })
    }
  },
  computed: {
    ...mapGetters({
      netPrice: 'getNetPrice',
      amount: 'getItemsAmount'
    })
  }
}
</script>

<style scoped>
.exit {
  width: 36px;
  height: 36px;
  float: right;
  margin-right: 5%;
  padding: 8px;
  color: #000000;
}

.ft {
  background-color: #439bec;
}

.hdr {
  background-color: #ececec;
}

.list-item {
  /* position: absolute; */
  overflow: auto;
  height: calc(100vh - 160px);
}

.footer-icon-disable {
  background-color: #65737e;
  border-radius: 18px;
  margin-top: 25px;
  width: 64px;
  height: 64px;
  border: 10px solid;
  border-color: #65737e;
}

.footer-icon {
  background-color: #ffffff;
  border-radius: 18px;
  margin-top: 25px;
  width: 64px;
  height: 64px;
  border: 10px solid;
  border-color: #ffffff;
}

.cart-item-count {
  border-radius: 50%;
  font-size: 15px;
  font-weight: bold;
}

.total-price{
  color: white;
  padding-top: 35px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ScanToCart.vue